import { Link } from "react-router-dom";
import Loader from "@/components/Loader/Loader";
import {
  BreadCrumbChevronIcon,
  CheckMiniIcon,
  GlobeMiniIcon,
} from "@/components/SVGComponents/MemberIcons";
import { useLanguage } from "@/contexts/LanguageContext";
import { PROFILE_BASE_PATH } from "@/pages/Profile/profilePaths";
import styles from "./Language.module.scss";

const FALLBACK_LANGUAGES = [
  {
    id: "en",
    languageCode: "en",
    languageName: "English",
    translations: {},
  },
];

const Language = () => {
  const {
    changeLanguage,
    error,
    isLoading,
    languages,
    selectedLanguage,
    t,
  } = useLanguage();
  const displayLanguages = languages.length > 0 ? languages : FALLBACK_LANGUAGES;

  return (
    <section className={styles.page}>
      <div className={styles.orbLeft} />
      <div className={styles.orbRight} />
      <div className={styles.dotsRight} />

      <div className={styles.inner}>
        <div className={styles.breadcrumbs}>
          <Link className={styles.breadcrumbLink} to={PROFILE_BASE_PATH}>
            {t(["profile.title", "Profile"], "Profile")}
          </Link>
          <BreadCrumbChevronIcon />
          <span className={styles.activeCrumb}>
            {t(["profile.language.title", "Language"], "Language")}
          </span>
        </div>

        <header className={styles.header}>
          <h1>{t(["profile.language.title", "Language"], "Language")}</h1>
          <p>
            {t(
              [
                "profile.language.description",
                "Choose your preferred language for the best experience.",
              ],
              "Choose your preferred language for the best experience.",
            )}
          </p>
        </header>

        <div className={styles.languageCard}>
          {isLoading ? (
            <div className={styles.statePanel}>
              <Loader fullscreen={false} size={84} />
            </div>
          ) : (
            <ul className={styles.languageList}>
              {displayLanguages.map((language) => {
                const isActive =
                  language.languageCode === selectedLanguage?.languageCode;

                return (
                  <li
                    className={`${styles.languageItem} ${
                      isActive ? styles.languageItemActive : ""
                    }`}
                    key={String(language.id)}
                  >
                    <button
                      aria-pressed={isActive}
                      className={styles.languageItemButton}
                      onClick={() => changeLanguage(language.languageCode)}
                      type="button"
                    >
                      <div className={styles.languageInfo}>
                        <span className={styles.languageIcon}>
                          <GlobeMiniIcon />
                        </span>
                        <span className={styles.languageName}>
                          {language.languageName}
                        </span>
                      </div>

                      {isActive ? (
                        <CheckMiniIcon className={styles.languageSelected} />
                      ) : null}
                    </button>
                  </li>
                );
              })}
            </ul>
          )}

          {error ? <p className={styles.helperText}>{error}</p> : null}
        </div>
      </div>
    </section>
  );
};

export default Language;
